<template>
  <v-card class="mb-4 hvh-card--rounded hvh-analysis-legend">
    <CardTitle :title="title" :class="{ 'pb-1': !isCollapsed }" v-model="isCollapsed" />
    <v-card-text class="pt-2" v-show="!isCollapsed">
      <dl class="hvh-analysis-legend__list">
        <div v-for="item in items" :key="item.label" class="mb-1">
          <dt>
            <svg viewBox="0 0 12 12">
              <path :fill="item.color" :d="item.path || defaultPath" />
            </svg>
          </dt>
          <dd>{{ item.label }}</dd>
        </div>
      </dl>
    </v-card-text>
  </v-card>
</template>

<script>
import CardTitle from '../common/cardTitle/HvhCardTitle.vue';
import { chartConfig } from '../../libraries/charts';

export default {
  components: { CardTitle },
  props: ['title', 'items'],
  data() {
    return {
      symbols: chartConfig.symbols,
      defaultPath: chartConfig.symbols.square,
      isCollapsed: false,
    };
  },
};
</script>

<style lang="scss">
.hvh-analysis-legend__list {
  > div {
    align-items: center;
    display: flex;
  }

  dt {
    flex: 0 0 12px;
    line-height: 1;
    margin-right: rem(13px);
  }

  dd {
    color: $color-text-default;
    flex: 1 1 auto;
  }
}
</style>
